import React from "react";

const ConfigPartFour = (props) => {
  const { handleClick, styles, step, configDetails, setconfigDetails, errors } =
    props;

  return (
    <>
      <textarea
        className="config_details"
        required
        style={{
          border: "solid 1px #0f907",
          color: "white",
          width: "100%",
          minHeight: "200px",
        }}
        value={configDetails}
        onChange={(e) => {
          const newValue = e.target.value;
          setconfigDetails(newValue);
        }}
      ></textarea>
      <div className="d-flex justify-content-around">
        {step === 4 ? (
          <div className="d-flex justify-content-around">
            <div className="prev">
              <button
                className="btn-class mt-3"
                type="button"
                name="btn-click"
                style={{ marginLeft: "1rem", marginRight: "1rem" }}
                onClick={() => handleClick("prev")}
              >
                PREV
              </button>
            </div>
            <div className="submit-config">
              <button
                className="btn-class mt-3"
                type="button"
                name="btn-click"
                style={{ marginLeft: "1rem", marginRight: "1rem" }}
                onClick={() => handleClick("submit")}
              >
                SUBMIT
              </button>
            </div>
          </div>
        ) : (
          <div className="d-flex justify-content-between">
            {step !== 0 && (
              <div>
                <button
                  className="btn-class mt-3"
                  type="button"
                  name="btn-click"
                  style={{ marginLeft: "1rem", marginRight: "1rem" }}
                  onClick={() => handleClick("prev")}
                >
                  PREV
                </button>
              </div>
            )}
            <div>
              <button
                className="btn-class mt-3 ml-2 mr-2"
                type="button"
                name="btn-click"
                style={{ marginLeft: "1rem", marginRight: "1rem" }}
                onClick={() => handleClick("next")}
              >
                NEXT
              </button>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default ConfigPartFour;
